<template>
	<div class="dialog" @click="animate">
		<div
			id="customDialog"
			class="popup animate"
			:class="`${theme}-theme`"
			:style="{ maxWidth: size === 'sm' ? '295px' : '364px', maxHeight: '90vh' }"
			@click="cancelEvent"
			@dblclick="cancelEvent">
			<slot name="popupHeader"></slot>
			<slot name="popupBody"></slot>
		</div>
	</div>
</template>

<script>
import { useStore } from '@/store';
import { computed } from 'vue';

export default {
	setup() {
		const store = useStore();

		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);

		const animate = () => {
			const popup = document.getElementById('customDialog');
			popup.classList.remove('animate');
			popup.classList.add('animate');

			setTimeout(() => {
				popup.classList.remove('animate');
			}, 200);
		};

		const cancelEvent = event => {
			event.stopImmediatePropagation();
		};

		return {
			theme,
			size,
			animate,
			cancelEvent,
		};
	},
};
</script>

<style>
.dialog {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
}

.animate {
	animation-name: scaling;
	animation-duration: 0.25s;
}

@keyframes scaling {
	from {
		transform: scale(1.03);
	}
	to {
		transform: scale(1);
	}
}

/* .popup {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    position: relative;
} */
</style>
